/* global radioFetchReportUrl radioExportReportUrl radioDownloadReportUrl radioCheckReportStatusUrl radioOptions radioChannelName radioInitialCriteria */

import React, { useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import { RadioReportProvider } from './RadioReportContext';
import RadioReportCriteria from './RadioReportCriteria';
import RadioReportTable from './RadioReportTable';

import SectionTile from 'CommonComponents/SectionTile';

/**
 * RADIO report builder (IB-678).
 *
 * Mounts into the #RadioReport div on the report-centre builder page. The
 * criteria controls live in a collapsible tile above the live results table;
 * both read/write the shared report context, which auto-fetches the on-screen
 * data on criteria change and drives the Excel export flow.
 */
const RadioReport = () => {
    const [criteriaCollapsed, setCriteriaCollapsed] = useState(false);

    return (
        <div className="tw-flex-auto tw-flex tw-flex-col tw-px-6 tw-py-6.5 tw-rounded-lg tw-bg-white tw-shadow-primary tw-space-y-7">
            <div className="tw-flex-initial tw-flex tw-items-center tw-justify-between tw-gap-3">
                <h2 className="tw-text-lg tw-font-semibold tw-text-charcoal tw-m-0">{$t('R.A.D.I.O. Report')}</h2>
            </div>

            <div className="tw-flex-initial">
                <SectionTile
                    flat
                    header={$t('Report Criteria')}
                    collapsed={criteriaCollapsed}
                    onToggle={() => setCriteriaCollapsed(!criteriaCollapsed)}
                    visibly
                >
                    <RadioReportCriteria />
                </SectionTile>
            </div>

            <RadioReportTable />
        </div>
    );
};

export default RadioReport;

const rootEl = document.getElementById('RadioReport');

if (rootEl) {
    ReactDOM.render(
        <App>
            <RadioReportProvider
                fetchReportUrl={radioFetchReportUrl}
                exportReportUrl={radioExportReportUrl}
                downloadReportUrl={radioDownloadReportUrl}
                checkStatusUrl={radioCheckReportStatusUrl}
                options={radioOptions}
                channelName={radioChannelName}
                initialCriteria={typeof radioInitialCriteria !== 'undefined' ? radioInitialCriteria : {}}
            >
                <RadioReport />
            </RadioReportProvider>
        </App>,
        rootEl,
    );
}
